<template>
<div class="d-flex" id="wrapper">
  <SideBar />
  <div id="page-content-wrapper">
    <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
      <div>
        <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
        </button>

        <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
        </button>
      </div>
      <div class="d-flex">
        <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
        <p class="text-primary mb-0 hover-cursor">&nbsp;Return / Unmatch Product</p>
      </div>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ admin }}
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
              <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
              <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
            </div>
          </li>
        </ul>
      </div>
    </nav>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 grid-margin stretch-card card-div">
          <div class="container">
            <h5 class="card-title mb-4">Unmatch Product</h5>
            <!-- Searchbar -->
            <div class="col-lg-12 px-0">
              <div id="filterPart" class="card" >
                <div class="row">
                  <div class="container" style="display : flex;">
                    <div class="col">
                      <div>Unique ID</div>
                      <input type="text" class="form-control" name="search_value" placeholder="SN/SC/PC/Acc.Name" v-model="searchValue" @input="resetErrorMessage">
                    </div>
                    <div class="col">
                      <span>Tipe Unit</span>
                      <multiselect v-model="searchType" :options="searchTypeOptions" label="typeName" :allow-empty="true" :select-label="''" :deselect-label="''" placeholder="All" track-by="typeName" :multiple="false" :close-on-select="true" default></multiselect>
                    </div>
                    <div class="col-lg-3 px-0 col-sm mobile-div mt-4">
                      <button class="btn btn-primary" @click="getData('dataTableSearch')"> Search </button>
                    </div>
                  </div>
                </div>
              </div>
            
            </div>
            <!-- Table Data -->
            <!-- Minta di hide 15/05/2023 -->
            <!-- <div> 
              <button class="btn btn-primary mt-3 mb-2" @click="AddProduct">Add</button>
            </div> -->
            <div class="mb-4"></div>
            <!-- table baru -->
            <table class="table table-sm table-bordered table-responsive-sm">
              <thead>
                <tr>
                  <th>Order Info</th>
                  <th>Product Info</th>
                  <th>Actual Specification</th>
                  <th style="width: 10rem;">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="loadingTable == true">
                  <td colspan="4" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                </tr>
                
                <template v-else-if="loadingTable == false && data.length > 0">
                  <template v-for="(order, i) in data[page]">
                    <!-- Kasus: Accessories (multiple items) -->
                    <template v-if="order.source === 'accessories'">
                      <!-- Baris pertama: Order Info + item pertama -->
                      <tr :key="`order-${i}-acc-0`">
                        <td :rowspan="order.dataAccessories.length" class="align-top">
                          <div>{{order.companyName}}</div>
                          <div class="text-primary redirect-link" style="width: fit-content" 
                              @click="toDetail(order.orderId, order.orderCode, order.companyId)">
                            {{order.orderCode}}
                          </div>
                        </td>
                        
                        <!-- Item accessories pertama (index 0) -->
                        <td class="align-top">
                          <div>Accessories: {{order.dataAccessories[0].itemName}}</div>
                          <div>Total Units: {{order.dataAccessories[0].totalQty}}</div>
                          <div>Total Unmatch: {{order.dataAccessories[0].unmatchQty}}</div>
                        </td>
                        
                        <td class="align-top"></td>
                        
                        <td class="text-center align-middle">
                          <button class="btn btn-info btn-sm mb-1"
                            style="min-width: 5.82rem;"
                            @click.prevent="showAccessoriesSwitchModal(order, 0)"
                          >
                            Switch
                          </button>
                          <br>
                          <button class="btn btn-danger btn-sm" 
                            style="background-color: #BE3846; min-width: 5.82rem;"
                            @click.prevent="showAccessoriesLostModal(order, 0)"
                          >
                            Lost
                          </button>
                        </td>
                      </tr>
                      
                      <!-- Baris sisanya: item accessories ke-2 dst -->
                      <tr v-for="(accData, accIndex) in order.dataAccessories.slice(1)" 
                          :key="`order-${i}-acc-${accIndex + 1}`">
                        <td class="align-top">
                          <div>Accessories: {{accData.itemName}}</div>
                          <div>Total Units: {{accData.totalQty}}</div>
                          <div>Total Unmatch: {{accData.unmatchQty}}</div>
                        </td>
                        
                        <td class="align-top"></td>
                        
                        <td class="text-center align-middle">
                          <button class="btn btn-info btn-sm mb-1" 
                            style="min-width: 5.82rem;"
                            @click.prevent="showAccessoriesSwitchModal(order, accIndex + 1)"
                          >
                            Switch
                          </button>
                          <br>
                          <button class="btn btn-danger btn-sm" 
                            style="background-color: #BE3846;min-width: 5.82rem;" 
                            @click.prevent="showAccessoriesLostModal(order, accIndex + 1)"
                          >
                            Lost
                          </button>
                        </td>
                      </tr>
                    </template>
                    
                    <!-- Kasus: Bukan Accessories (single item) -->
                    <tr v-else :key="`order-${i}-single`">
                      <td>
                        <div>{{order.companyName}}</div>
                        <div class="text-primary redirect-link" style="width: fit-content" 
                            @click="toDetail(order.orderId, order.orderCode, order.companyId)">
                          {{order.orderCode}}
                        </div>
                      </td>
                      
                      <td>
                        <div>{{order.productName}}</div>
                        <div>{{order.spec}}</div>
                        <div>Product Code: {{order.productCode}}</div>
                        <div>Serial Number: {{order.serialNumber || '-'}}</div>
                        <div>Stock Code: {{order.stockCode || '-'}}</div>
                      </td>
                      
                      <td>
                        <div v-if="!order.bomItem.length">
                          <div v-for="(value, name) in order.actualSpec" :key="name">{{name}} : {{value}}</div>
                          <!-- <div v-for="(value, name) in order.actualSpec" :key="name + value + 'x'">
                            <div class="container">
                              <div class="row">
                                <div>{{name + ' : '}}</div>
                                <div class="pl-1">{{value}}</div>
                              </div>
                            </div>
                          </div> -->
                        </div>
                        <div v-else>
                          <div v-for="(item, idx) in order.bomItem" :key="`${item.itemName}-${idx}`">
                            <div class="mb-2">
                              <strong>{{item.itemGroup}} :</strong>
                              <div class="ml-3">
                                <div v-for="(qty, qtyIndex) in item.itemQty" :key="`qty-${idx}-${qtyIndex}`">
                                  • {{item.itemName}}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      
                      <td class="text-center align-middle">
                        <button class="btn btn-info btn-sm mb-2" @click.prevent="openSwitch(order)" style="min-width: 5.82rem;">
                          Switch
                        </button>
                        <br>
                        <button class="btn btn-secondary btn-sm" @click.prevent="ProcessQc(order)" style="min-width: 5.82rem;">
                          Process QC
                        </button>
                      </td>
                    </tr>
                  </template>
                </template>
                
                <tr v-else-if="loadingTable == false && data.length == 0">
                  <td colspan="4" class="text-center">
                    Data not Available
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- End of table baru -->
            <!-- <table class="table table-sm table-bordered table-striped table-responsive-sm">
              <thead>
                <tr>
                  <th>Order Info</th>
                  <th>Product Info</th>
                  <th>Actual Specification</th>
                  <th style="width: 10rem;">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="loadingTable == true">
                  <td colspan="5" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                </tr>
                <tr v-else-if="loadingTable == false && data.length > 0" v-for="(order,i) in data[page]" :key="`order-${i}`">
                  <td>
                    <div v-if="order.source !== 'accessories'">
                      <div>{{order.companyName}}</div>
                      <div class="text-primary redirect-link" style="width: fit-content" @click="toDetail(order.orderId,order.orderCode,order.companyId)">{{order.orderCode}}</div>
                      <div>{{order.productName}}</div>
                      <div>{{order.spec}}</div>
                    </div>
                    <div v-else>
                      <div>{{order.companyName}}</div>
                      <div class="text-primary redirect-link" style="width: fit-content" @click="toDetail(order.orderId,order.orderCode,order.companyId)">{{order.orderCode}}</div>
                
                      <div v-for="(accData,accIndex) in order.dataAccessories" :key="`accessories-${i}-${accIndex}`" style="margin-bottom: 2rem; margin-top: 1rem;">
                        <div>
                          <div>Accessories : {{accData.itemName}}</div>
                          <div>Total Units : {{accData.totalQty}}</div>
                          <div>Total Unmatch : {{accData.unmatchQty}}</div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td >
                    <div v-if="order.source !== 'accessories'">
                      <div>Product Code : {{order.productCode}}</div>
                      <div>Serial Number : {{order.serialNumber || '-'}}</div>
                      <div>Stock Code : {{order.stockCode || '-'}}</div>
                      <div v-if="!order.bomItem.length">
                        <div v-for="(value, name) in order.actualSpec" :key="name+value+'x'">
                          <div class="container">
                            <div class="row">
                              <div>{{name + ' : '}}</div>
                              <div class="pl-1">{{value}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div v-for="(item,i) in order.bomItem" :key="`${item.itemName}-${i}`">
                          <div class="container">
                            <div class="row">
                              <div>{{item.itemGroup + ' : '}}</div>
                              <div class="pl-1" v-for="(qty,j) in item.itemQty" :key="`${item.itemName}-${i}-${j}`">{{item.itemName}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="text-center">
                    <div style="margin-top: 3.3rem;" v-if="order.source == 'accessories'">
                      <div v-for="(item,i) in order.dataAccessories" :key="`data-${i}`">
                        <div style="margin-bottom: 3.6rem;">
                          <div class="mt-2">
                            <button class="btn btn-info" @click.prevent="showAccessoriesSwitchModal(order,i)">Switch</button>
                          </div>
                          <div class="mt-1">
                            <button class="btn btn-danger" style="background-color: #BE3846;" @click.prevent="showAccessoriesLostModal(order,i)">Lost</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-else>
                      <div class="mt-2">
                        <button class="btn btn-info" @click.prevent="openSwitch(order)">Switch</button>
                      </div>
                      <div class="mt-2">
                        <button class="btn btn-secondary" @click.prevent="ProcessQc(order)">Process QC</button>
                      </div>
                    </div>
                    
                  </td>
                </tr>
                <tr v-else-if="loadingTable == false && data.length == 0">
                  <td colspan="3" class="text-center">
                    Data no Available
                  </td>
                </tr>
              </tbody>
            </table> -->
            <div id="wrapperr">
              <div id="c1" style="display: inline-flex;">
                <div style="margin-right: 10px;">
                  <select class="form-control form-control-sm" v-model="itemPerPage" @change="searchData()">
                    <option :value="10">10</option>
                    <option :value="40">40</option>
                    <option :value="80">80</option>
                  </select>
                </div>
                <div class="alignLeft total-data">
                  Total Data {{ totalData }}
                </div>
              </div>
              <div id="c2" v-if="totalPage > 0">
                <div class="pagination p8 alignRight">
                  <ul>
                    <a class="is-active link" @click="toDataPage(page-1)" v-if="page != 0">
                      <li>{{'<'}} </li> 
                    </a> 
                    <a class="page">
                      <li>{{ page + 1 }} of {{ totalPage }} page</li>
                    </a>
                    <a class="is-active link" @click="toDataPage(page + 1)" v-if="page + 1 < totalPage">
                      <li>></li>
                    </a>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Modals -->

  <div class="modal fade" id="modalProcessQc" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <div class="change-title">
            <h4 class="modal-title">{{dataProduct.productName}}</h4>
          </div>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="one-line">
            <div class="container">
              <div class="row align-items-center">
                <div class="col-lg-12 px-0">
                  <label class="ol-label mb-0">Apakah anda akan meneruskan product untuk process QC?</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary btn-sm" v-if="loadingProcessQc == false" @click="submitProcessQc">Save</button>
          <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;" />Save</button>
        </div>
      </div>
    </div>
  </div>

<!-- Minta di Hide 15/05/2023 -->
  <!-- <div class="modal fade" id="modalAddProduct" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <div class="change-title">
            <h4 class="modal-title">Add Return Item</h4>
          </div>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="one-line">
            <div class="container">
              <div class="row">
                <div class="col-lg-4 col-sm mobile-div pl-0">
                  <div>Unique ID</div>
                  <input type="text" class="form-control" name="search_value" placeholder="SN/SC/PC" v-model="searchAddValue" @input="resetErrorMessage">
                </div>
                <div class="col-lg-3 px-0 col-sm mobile-div mt-4">
                  <button class="btn btn-primary" @click="getData('add')" :disabled="loadingSearchAdd"> Search </button>
                </div>
              </div>
              <div class="row my-2" v-if="errorMessageAdd != ''">
                <label class="ol-label text-danger">{{errorMessageAdd}}</label>
              </div>
            </div>
          </div>
          <div class="row mt-2 border mb-2 p-2" style="margin-left: 1px; margin-right: 1px;" v-if="productSearch.length != 0">
            <div class="col-6">
              <div><b>Order Info</b></div>
              <div>{{productSearch.companyName}}</div>
              <div @click="toDetail(productSearch.orderId, productSearch.orderCode, productSearch.companyId)" class="text-primary redirect-link">{{productSearch.orderCode}}</div>
              <div><b>Catalog Specification</b></div>
              <div>{{productSearch.productName}}</div>
              <div>{{productSearch.spec}}</div>
            </div>
            <div class="col-6">
              <div><b>Actual Specification</b></div>
              <div v-for="(value, name) in productSearch.actualSpec">
                <span>{{ name }} : {{ value }} </span>
              </div>
              <div>Product Code : {{productSearch.productCode}}</div>
              <div>Serial Number : {{productSearch.serialNumber || '-'}}</div>
              <div>Stock Code : {{productSearch.stockCode || '-'}}</div>
              <div>Price : {{tocur(productSearch.price) || '-'}}</div>
              <div>End Rent : {{productSearch.endRent || '-'}}</div>
            </div>
          </div>
          <div class="row mb-2" style="margin-left: 1px; margin-right: 1px;" v-if="productSearch.length != 0">
            <div class="col-12 p-0">
              <div class="d-flex align-items-start">
                <div style="width: 72px;">Notes : </div>
                <textarea class="form-control" style="resize: none" rows="3" v-model="itemNote" @input="resetErrorNote"></textarea>
              </div>
            </div>
          </div>
          <div class="row mt-1" style="margin-left: 1px;" v-if="errorMessageNote != ''">
            <label class="ol-label text-danger">{{errorMessageNote}}</label>
          </div>
          <div class="row" style="margin-left: 1px; margin-right: 1px;" v-if="productSearch.length != 0">
            <div class="col-12 p-0">
              <div class="d-flex align-items-center">
                <div style="width: 72px;">Status : </div>
                <select v-model="orderStatus" class="form-control" @change="cekStatus">
                  <option value="">None</option>
                  <option value="17">Return Match</option>
                  <option value="18">Return Unmatch</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row mt-1" style="margin-left: 1px;" v-if="errorMessageStatus != ''">
            <label class="ol-label text-danger">{{errorMessageStatus}}</label>
          </div>
        </div>
        <div class="modal-footer" v-if="productSearch.length != 0">
          <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary btn-sm" :disabled="loadingSaveAdd" @click="submitAddReturn"><img src="~@/assets/images/2.gif" style="height: 18px;" v-if="loadingSaveAdd" />Save</button>
        </div>
      </div>
    </div>
  </div> -->

  <div class="modal fade" id="modalSwitch" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <div class="change-title">
            <h4 class="modal-title">Switch</h4>
          </div>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="one-line">
            <div class="container">
              <div class="row mb-1">{{dataProduct.companyName}}</div>
              <div class="row">
                <div class="col-lg-4 col-sm mobile-div pl-0">
                  <div>Unique ID</div>
                  <input type="text" class="form-control" name="search_value" placeholder="SN/SC/PC" v-model="searchSwitchValue" @input="resetErrorMessage">
                </div>
                <div class="col-lg-3 px-0 col-sm mobile-div mt-4">
                  <button class="btn btn-primary" @click="getData('switch')" :disabled="loadingSearchSwitch"> Search </button>
                </div>
              </div>
              <div class="row my-2" v-if="errorMessageSwitch != ''">
                <label class="ol-label text-danger">{{errorMessageSwitch}}</label>
              </div>
            </div>
          </div>
          <div class="row mt-2 mb-2" style="margin-left: 1px; margin-right: 1px;">
            <div class="col-5 text-center mb-2">
              <div>Unit harus kembali sesuai kontrak</div>
            </div>
            <div class="col-2"></div>
            <div class="col-5 text-center mb-2">
              <div v-if="productSearch.length != 0">Unit dikembalikan</div>
            </div>
            <div class="col-5 p-2 border">
              <div @click="toDetail(dataProduct.orderId, dataProduct.orderCode, dataProduct.companyId)" class="text-primary redirect-link">{{dataProduct.orderCode}}</div>
              <div><b>Catalog Specification</b></div>
              <div>{{dataProduct.productName}}</div>
              <div>{{dataProduct.spec}}</div>
              <div><b>Actual Specification</b></div>
              <div v-if="!dataProduct.bomItem">
                <div v-for="(value, name) in dataProduct.actualSpec" :key="name">
                  <span>{{ name }} : {{ value }} </span>
                </div>
              </div>
              <div v-else>
                <div v-for="(value, i) in dataProduct.bomItem" :key="`${value.itemName}-${i}`">
                  <div class="container">
                    <div class="row">
                      <div class="pr-1">{{value.itemGroup}} :</div>
                      <div class="pl-1">
                        <div v-for="(val, j) in value.itemQty" :key="`${value.itemName}-${i}-${j}`">
                          {{value.itemName}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>Product Code : {{dataProduct.productCode}}</div>
              <div>Serial Number : {{dataProduct.serialNumber || '-'}}</div>
              <div>Stock Code : {{dataProduct.stockCode || '-'}}</div>
            </div>
            <div class="col-2 d-flex align-items-center justify-content-center">
              <div class="align-middle" v-if="productSearch.length != 0"> >> </div>
            </div>
            <div class="col-5 p-2 border" v-if="productSearch.length != 0">
              <div @click="toDetail(productSearch.orderId, productSearch.orderCode, productSearch.companyId)" class="text-primary redirect-link">{{productSearch.orderCode}}</div>
              <div><b>Catalog Specification</b></div>
              <div>{{productSearch.productName}}</div>
              <div>{{productSearch.spec}}</div>
              <div><b>Actual Specification</b></div>
              <div v-if="!productSearch.bomItem">
                <div v-for="(value, name) in productSearch.actualSpec" :key="name">
                  <span>{{ name }} : {{ value }} </span>
                </div>
              </div>
              <div v-else>
                <div v-for="(value, i) in productSearch.bomItem" :key="`${value.itemName}-${i}`">
                  <div class="container">
                    <div class="row">
                      <div class="pr-1">{{value.itemGroup}} :</div>
                      <div class="pl-1">
                        <div v-for="(val, j) in value.itemQty" :key="`${value.itemName}-${i}-${j}`">
                          {{value.itemName}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>Product Code : {{productSearch.productCode}}</div>
              <div>Serial Number : {{productSearch.serialNumber || '-'}}</div>
              <div>Stock Code : {{productSearch.stockCode || '-'}}</div>
            </div>
          </div>
        </div>
        <div class="modal-footer" v-if="productSearch.length != 0">
          <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary btn-sm" :disabled="loadingSaveSwitch" @click="submitSwitch"><img src="~@/assets/images/2.gif" style="height: 18px;" v-if="loadingSaveSwitch" />Save</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Switch -->
   <ModalAccessoriesSwitch :orderData="selectedOrderAccessoriesData" :toOrderDetail="toDetail"/>
  <!-- Modal Unmatch -->
   <ModalAccessoriesLost ref="modalAccessoriesLost" :orderData="selectedOrderAccessoriesData" :toOrderDetail="toDetail" :pageType="'unmatch'"/>
  <!-- End Modals -->
</div>
</template>

<script>
import SideBar from '../SideBar'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
// custom component import
import ModalAccessoriesLost from '../QC/CustomComponent/ModalAccessoriesLost.vue';
import ModalAccessoriesSwitch from '../QC/CustomComponent/ModalAccessoriesSwitch.vue';

export default {
  name: 'UnmatchProductPage',
  components: {
    SideBar,
    Multiselect,
    ModalAccessoriesLost,
    ModalAccessoriesSwitch
  },
  data() {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      admin: '',
      permission: [],
      addStockOpt: 0,
      loadingTable: true,
      loadingButtonSave: false,
      loadingProcessQc: false,
      loadingSearchAdd: false,
      loadingSearchSwitch: false,
      loadingSaveAdd: false,
      loadingSaveSwitch: false,
      errorMessageAdd: '',
      errorMessageSwitch: '',
      errorMessageSearch: '',
      page: 0,
      totalPage: 0,
      itemPerPage: 10,
      totalData: 0,
      data: [],
      searchValue: '',
      searchType : { typeName : 'All'},
      searchAddValue: '',
      searchSwitchValue: '',
      productType: '',
      productData: {
        catalogName: '',
        catalogSpec: '',
        catalogType: '',
        condition: '',
        lessorPointId: '',
        lessorPointName: '',
        price: '',
        productId: '',
        orderDetailsId: ''
      },
      addStockSpec: {
        Processor: '',
        RAM: '',
        Storage: '',
        VGA: ''
      },
      addStockInfo: {
        serialNumber: '',
        stockCode: '',
      },
      addAction: {
        action: 0,
        actionName: 'None'
      },
      actionSelection: [],
      dataProduct: [],
      productSearch: [],
      orderStatus: '',
      errorMessageStatus: '',
      errorMessageNote: '',
      btnPush: false,
      itemNote: '',
      selectedOrderAccessoriesData : {},
      searchTypeOptions : [
        {
          typeName : 'All',
        },
        {
          typeName : 'Unit',
        },
        {
          typeName : 'Accessories',
        },
      ],
    }
  },
  methods: {
    showAccessoriesSwitchModal(order, accNo) {
      this.selectedOrderAccessoriesData = {...order, dataAccessories : order.dataAccessories[accNo], ...order.dataAccessories[accNo]}
      $('#modalAccessoriesSwitch').modal('show')
    },
    showAccessoriesLostModal (order, accNo) {
      this.selectedOrderAccessoriesData = {...order, dataAccessories : order.dataAccessories[accNo], ...order.dataAccessories[accNo]}
      this.$nextTick(() => {
        this.$refs.modalAccessoriesLost.showModal()
      })
    },
    tocur(amount) {
      return "Rp " + amount
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    resetErrorNote() {
      if (this.itemNote != '') {
        this.errorMessageNote = ''
      }
    },
    openSwitch(dataProduct) {
      this.dataProduct = dataProduct
      this.searchSwitchValue = ''
      this.productSearch = []
      $("#modalSwitch").modal('show')
    },
    submitSwitch() {
      this.loadingSaveSwitch = true
      this.$http.post(process.env.SUBMIT_SWITCH, {
          orderDetailsIdContract: parseInt(this.dataProduct.orderDetailsId),
          orderDetailsIdReturn: parseInt(this.productSearch.orderDetailsId),
        }, {
          timeout: 30 * 1000,
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then(res => {
          if (res.data.status == 200) {
            swal("Success", res.data.message, "success", {
              button: "Close",
            })
            this.searchValue = ''
          } else {
            swal("Sorry", res.data.message, "error", {
              button: "Close",
            })
          }
          this.loadingSaveSwitch = false
          this.getData('dataTable')
          $("#modalSwitch").modal('hide')
        })
        .catch(error => {
          console.log(error)
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            this.loadingSaveSwitch = false
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    cekStatus() {
      if (this.orderStatus != '') {
        this.errorMessageStatus = ''
      }
    },
    submitAddReturn() {
      if (this.itemNote != '') {
        if (this.orderStatus != '') {
          this.loadingSaveAdd = true
          this.errorMessageStatus = ''
          this.$http.post(process.env.ADD_RETURN, {
              orderDetailsId: this.productSearch.orderDetailsId,
              orderId: this.productSearch.orderId,
              orderStatus: this.orderStatus,
              itemNote: this.itemNote.replace(this.spaceRegex, ' '),
            }, {
              timeout: 30 * 1000,
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            })
            .then(res => {
              if (res.data.status == 200) {
                swal("Success", res.data.message, "success", {
                  button: "Close",
                })
                this.itemNote = ''
              } else {
                swal("Sorry", res.data.message, "error", {
                  button: "Close",
                })
              }
              this.loadingSaveAdd = false
              this.searchValue = ''
              this.getData('dataTable')
              $("#modalAddProduct").modal('hide')
              this.errorMessageStatus = ''
              this.errorMessageNote = ''
            })
            .catch(error => {
              swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
              }).then(v => {
                if(error.response.data.status == 401) {
                  this.handleLogout()
                }
              })
            })
        } else {
          this.errorMessageStatus = 'Status harus dipilih'
        }
      } else {
        this.errorMessageNote = 'Note harus diisi'
      }
    },
    toDetail(id, orderCode, companyId) {
      window.open(this.$router.resolve({
        path: '/order/detail/' + id,
        query: {
          orderCode: orderCode,
          companyIdDetail: companyId
        }
      }).href, '_blank');
    },
    resetErrorMessage() {
      this.errorMessageAdd = ''
      this.errorMessageSwitch = ''
      this.errorMessageStatus = ''
      this.errorMessageSearch = ''
      this.orderStatus = ''
      this.btnPush = false
    },
    // AddProduct() {
    //   this.searchAddValue = ''
    //   this.productSearch = []
    //   $("#modalAddProduct").modal('show')
    // },
    ProcessQc(dataProduct) {
      this.dataProduct = {
        productName: dataProduct.productName,
        orderDetailsId: dataProduct.orderDetailsId
      }
      $("#modalProcessQc").modal('show')
    },
    submitProcessQc() {
      this.loadingProcessQc = true
      this.$http.post(process.env.PROCESS_QC, {
          orderDetailsId: this.dataProduct.orderDetailsId
        }, {
          timeout: 30 * 1000,
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then(res => {
          if (res.data.status == 200) {
            swal("Success", res.data.message, "success", {
              button: "Close",
            }).then(() => {
              this.searchValue = ''
              this.loadingProcessQc = false
              this.getData('dataTable')
              $("#modalProcessQc").modal('hide')
            })
          } else {
            swal("Sorry", res.data.message, "error", {
              button: "Close",
            })
            this.searchValue = ''
            this.loadingProcessQc = false
            this.getData('dataTable')
            $("#modalProcessQc").modal('hide')
          }
        })
        .catch(error => {
          this.loadingProcessQc = false
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    toPage(e) {
      this.$router.push(e)
    },
    toDataPage(val) {
      this.page = val
    },
    searchData() {
      this.$http.post(process.env.SEARCH_UNMATCH_DATA_TABLE, {
          uniqueId: this.searchValue,
          tipe : this.searchType.typeName,
          companyId: this.dataProduct.companyId
        }, {
          timeout: 30 * 1000,
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then(res => {
          if (res.data.status == 200) {
            if (res.data.data.length > 0) {
              const chunk = (arr, size) =>
                Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
                  arr.slice(i * size, i * size + size)
                )
              let result = chunk(res.data.data, this.itemPerPage)
              this.totalPage = result.length
              this.totalData = res.data.data.length,
              this.data = result
              this.loadingTable = false
            } else {
              swal("Sorry", "Data tidak ditemukan.", "error", {
                button: "Close",
              })
              this.loadingTable = false
            }
          } else {
            swal("Sorry", res.data.message, "error", {
              button: "Close",
            })
            this.loadingTable = false
          }
          this.loadingTable = false
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })

    },
    getData(data) {
      var search = ''
      this.resetErrorMessage()
      if (data == 'dataTable') {
        search = this.searchValue
      } else if (data == 'dataTableSearch') {
        data = 'dataTable'
        this.btnPush = true
        search = this.searchValue
      } else if (data == 'add') {
        this.loadingSearchAdd = true
        search = this.searchAddValue
      } else if (data == 'switch') {
        this.loadingSearchSwitch = true
        search = this.searchSwitchValue
      }
      if ((search != '' && data != 'dataTable') || data == 'dataTable') {
        let endPointURL = data == 'dataTable' ? process.env.SEARCH_UNMATCH_DATA_TABLE : process.env.SEARCH_UNMATCH + "/" + data
        let payload = {
          uniqueId: search.replace(this.spaceRegex, ' '),
          companyId: this.dataProduct.companyId,
          tipe : this.searchType.typeName,
        }
        if (data === 'dataTable') {
          endPointURL = process.env.SEARCH_UNMATCH_DATA_TABLE
        } else if (data === 'switch') {
          endPointURL = process.env.RETURN_SWITCH
          payload = {
            uniqueId: search.replace(this.spaceRegex, ' '),
            companyId:this.dataProduct.companyId,
            catalogId: this.dataProduct.catalogId,
            price: this.dataProduct.price,
          }
        }
        this.$http.post(endPointURL, payload, {
            timeout: 30 * 1000,
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          })
          .then(res => {
            if (data == 'dataTable') {
              if (res.data.status == 200) {
                if (res.data.data.length > 0) {
                  const chunk = (arr, size) =>
                    Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
                      arr.slice(i * size, i * size + size)
                    )
                  let result = chunk(res.data.data, this.itemPerPage)
                  this.totalPage = result.length
                  this.totalData = res.data.data.length,
                    this.data = result
                  this.loadingTable = false
                  this.page = 0
                } else {
                  swal("Sorry", "Data tidak ditemukan.", "error", {
                    button: "Close",
                  })
                  this.loadingTable = false
                }
              } else {
                if (this.btnPush == true) {
                  // this.errorMessageSearch = res.data.message
                  swal("Sorry", 'Data tidak ditemukan', "error", {
                    button: "Close",
                  })
                  this.data = []
                } else {
                  this.data = []
                }
                this.loadingTable = false
              }
              this.loadingTable = false
            } else if (data == 'add' || data == 'switch') {
              if (res.data.status == 200) {
                this.productSearch = data === 'switch'? res.data.data[0]:res.data.content[0]
              } else {
                this.errorMessageAdd = res.data.message
                this.errorMessageSwitch = res.data.message
              }
              this.loadingSearchAdd = false
              this.loadingSearchSwitch = false
              this.orderStatus = ''
            }
          })
          .catch(error => {
            this.loadingTable = false
            this.loadingSearchAdd = false
            this.loadingSearchSwitch = false
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          })
      } else {
        this.errorMessageAdd = 'Unique id harus di isi'
        this.errorMessageSwitch = 'Unique id harus di isi'
        this.loadingSearchAdd = false
        this.loadingSearchSwitch = false
      }
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin() {
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    cekPermission() {
      this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == "1") {
          this.viewDashboard = true
        }
        if (this.permission[i] == "2.1") {
          this.viewOrder = true
        }
        if (this.permission[i] == "2.2") {
          this.editOrder = true
        }
        if (this.permission[i] == '3.1') {
          this.viewReturn = true
        }
        if (this.permission[i] == '3.2') {
          this.editReturn = true
        }
        if (this.permission[i] == '4.1') {
          this.viewProduct = true
        }
        if (this.permission[i] == '4.2') {
          this.editProduct = true
        }
        if (this.permission[i] == '5.1') {
          this.viewPairing = true
        }
        if (this.permission[i] == '5.2') {
          this.editPairing = true
        }
        if (this.permission[i] == '6') {
          this.viewReconcile = true
        }
        if (this.permission[i] == '7.1') {
          this.viewResolution = true
        }
        if (this.permission[i] == '7.2') {
          this.editResolution = true
        }
        if (this.permission[i] == '8.1') {
          this.viewLessor = true
        }
        if (this.permission[i] == '8.2') {
          this.editLessor = true
        }
        if (this.permission[i] == '9.1') {
          this.viewLessee = true
        }
        if (this.permission[i] == '9.2') {
          this.editLessee = true
        }
        if (this.permission[i] == '10') {
          this.viewEmployee = true
        }
      }
      if (this.viewOrder == false) {
        this.$router.push('/')
      }
    },
  },
  created() {
    this.cekLogin()
    this.cekPermission()
    this.admin = localStorage.getItem('admin_name')
    this.getData('dataTable')
  }
}
</script>

<style scoped>
#filterPart {
  padding: 1rem;
  background-color: #F8F9FA;
}
.one-line-sm {
  display: flex;
}

.pagination {
  padding: 0px 0;
}

.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a {
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
}

.p8 a:hover {
  text-decoration: none;
}

.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}

.p8 .is-active {
  background-color: #fff;
  color: #2797FB;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.pagg {
  display: inline-flex;
  overflow: auto;
}

.total-data {
  padding: 11px 0px;
  font-size: 14px;
  color: #343A40;
}

#wrapperr {
  overflow: auto;
  margin: 5px 3px;
}

#c1 {
  float: left;
}

#c2 {
  float: right;
}

.search-table {
  padding-bottom: 7px;
  margin-top: -5px;
  margin-left: -15px;
}

.active {
  color: #2797FB;
}

.right-dropdown {
  margin-left: 7px;
}

.account-div {
  margin: 2px 2px;
}

.right-arrow {
  margin-left: auto;
}

.brand-logo {
  width: 120px;
}

.menu-title {
  margin-left: 1.125rem;
}

.menu-title-order {
  margin-left: 1.95rem;
}

.menu-title-payment {
  margin-left: 1.525rem;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  /*width: 200px;*/
  /*background-color: #f1f1f1;*/
}

li.sidebar a {
  display: block;
  color: #000;
  padding: 8px 63px;
  text-decoration: none;
}

li a.active {
  background-color: #4CAF50;
  color: white;
}

li a:hover:not(.active) {
  background-color: #2797FB;
  color: white;
}

.redirect-link {
  text-decoration: underline #2797FB;
  cursor: pointer;
}

.nav-side-menu {
  overflow: auto;
  font-family: verdana;
  font-size: 12px;
  font-weight: 200;
  background-color: #2e353d;
  position: fixed;
  top: 0px;
  width: 300px;
  height: 100%;
  color: #e1ffff;
}

.nav-side-menu .brand {
  background-color: #23282e;
  line-height: 50px;
  display: block;
  text-align: center;
  font-size: 14px;
}

.nav-side-menu .toggle-btn {
  display: none;
}

.nav-side-menu ul,
.nav-side-menu li {
  list-style: none;
  padding: 0px;
  margin: 0px;
  line-height: 35px;
  cursor: pointer;
}

.nav-side-menu ul :not(collapsed) .arrow:before,
.nav-side-menu li :not(collapsed) .arrow:before {
  font-family: FontAwesome;
  content: "\f078";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}

.nav-side-menu ul .active,
.nav-side-menu li .active {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
}

.nav-side-menu ul .sub-menu li.active,
.nav-side-menu li .sub-menu li.active {
  color: #d19b3d;
}

.nav-side-menu ul .sub-menu li.active a,
.nav-side-menu li .sub-menu li.active a {
  color: #d19b3d;
}

.nav-side-menu ul .sub-menu li,
.nav-side-menu li .sub-menu li {
  background-color: #181c20;
  border: none;
  line-height: 28px;
  border-bottom: 1px solid #23282e;
  margin-left: 0px;
}

.nav-side-menu ul .sub-menu li:hover,
.nav-side-menu li .sub-menu li:hover {
  background-color: #020203;
}

.nav-side-menu ul .sub-menu li:before,
.nav-side-menu li .sub-menu li:before {
  font-family: FontAwesome;
  content: "\f105";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}

.nav-side-menu li {
  padding-left: 0px;
  border-left: 3px solid #2e353d;
  border-bottom: 1px solid #23282e;
}

.nav-side-menu li a {
  text-decoration: none;
  color: #e1ffff;
}

.nav-side-menu li a i {
  padding-left: 10px;
  width: 20px;
  padding-right: 20px;
}

.nav-side-menu li:hover {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
}

@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }

  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }

  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}

@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}

@media (max-width: 573px) {
  .mobile-div {
    padding: 2px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UnmatchProduct/UnmatchProduct.vue